// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__ZEzP6","timer__text":"Timer_timer__text__ks4ha"};